import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import DepartmentForm from '../Form';
import {
	fetchDepartment,
	updateDepartment,
} from '@resources/Department/actions';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash.isempty';

const Update = (props) => {
	const {
		fetchDepartment,
		department,
		updateDepartment,
		visible,
		onCancel,
	} = props;
	const intl = useIntl();

	useEffect(() => {
		const fetchData = async () => {
			await fetchDepartment(visible);
		};
		visible && fetchData();
	}, [fetchDepartment, visible]);

	const handleSubmit = useCallback(
		(data) => {
			return updateDepartment(department._id, data)
				.then((response) => {
					popIn(
						'success',
						intl.formatMessage({
							id: 'message.success.department.update',
							defaultMessage:
								'An existing Department entry has been successfully updated',
						})
					);

					onCancel && onCancel();
				})
				.catch((err) => Promise.reject(err));
		},
		[department]
	);

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.update.department',
					defaultMessage: 'Update Department',
				})}
			</Title>
			{!isEmpty(department) && (
				<DepartmentForm
					data={department}
					onSubmit={handleSubmit}
					{...props}
				/>
			)}
		</Modal>
	);
};

const mapStateToProps = ({
	department,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
}) => {
	return {
		department,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
	};
};

export default connect(mapStateToProps, {
	fetchDepartment,
	updateDepartment,
})(Update);
